import {
  DeviceSyncTypeEnum,
  FeatureEnum,
} from '@/shared/types/types.generated';

export const BACKUP_JOBS = [
  FeatureEnum.ProjectBackup,
  FeatureEnum.FtpBackup,
  FeatureEnum.SmbBackup,
  FeatureEnum.DeviceSnapshot,
  FeatureEnum.ReadVariableListFromDevice,
];

export const RESTORE_JOBS = [FeatureEnum.FtpRestore, FeatureEnum.SmbRestore];

export const TARGET_JOB_TYPES = [
  FeatureEnum.FtpBackup,
  FeatureEnum.SmbBackup,
  FeatureEnum.DeviceSnapshot,
  FeatureEnum.ReadVariableListFromDevice,
];

export const NON_PROJECT_JOB_TYPES = [
  FeatureEnum.DeviceSnapshot,
  FeatureEnum.ReadVariableListFromDevice,
];

// Features whose step configuration starts from the project (select a project,
// then check its devices) instead of from the device.
export const PROJECT_FIRST_FEATURES = [
  FeatureEnum.ProjectBackup,
  FeatureEnum.Deployment,
];

export const isProjectFirstFeature = (feature: FeatureEnum) =>
  PROJECT_FIRST_FEATURES.includes(feature);

export const FEATURE_TO_SYNC_TYPE: Partial<
  Record<FeatureEnum, DeviceSyncTypeEnum>
> = {
  [FeatureEnum.ProjectBackup]: DeviceSyncTypeEnum.Ide,
  [FeatureEnum.FtpBackup]: DeviceSyncTypeEnum.Ftp,
  [FeatureEnum.SmbBackup]: DeviceSyncTypeEnum.Smb,
  [FeatureEnum.DeviceSnapshot]: DeviceSyncTypeEnum.DeviceSnapshot,
  [FeatureEnum.ReadVariableListFromDevice]:
    DeviceSyncTypeEnum.ReadVariableListFromDevice,
};

export const SYNC_TYPE_TO_FEATURE = Object.fromEntries(
  Object.entries(FEATURE_TO_SYNC_TYPE).map(([k, v]) => [v, k as FeatureEnum]),
) as Partial<Record<DeviceSyncTypeEnum, FeatureEnum>>;
